import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Star, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';

const QualitySection = () => {
  return (
    <div className="max-w-[1400px] mx-auto" data-testid="quality-section">
      {/* Kilim Pattern Divider */}
      <div className="h-3 mb-12"
        style={{
          backgroundImage: `repeating-linear-gradient(90deg, 
            #78350f 0px, #78350f 30px, 
            #dc2626 30px, #dc2626 60px, 
            #f59e0b 60px, #f59e0b 90px,
            #ea580c 90px, #ea580c 120px)`
        }}
      ></div>

      <div className="bg-gradient-to-br from-stone-50 to-amber-50 py-16 px-8 relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `
              repeating-linear-gradient(45deg, transparent, transparent 40px, #78350f 40px, #78350f 42px),
              repeating-linear-gradient(-45deg, transparent, transparent 40px, #dc2626 40px, #dc2626 42px)
            `
          }}
        ></div>

        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Left Side - Text */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-px w-8 bg-amber-600"></div>
              <Sparkles className="h-4 w-4 text-amber-600" />
              <span className="text-amber-700 text-sm tracking-[0.2em] uppercase font-medium">Premium Quality</span>
            </div>
            
            <h2 className="text-4xl font-black text-stone-900 mb-4 leading-tight">
              Crafted with
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-amber-700 to-red-700">
                Passion
              </span>
            </h2>
            
            <p className="text-stone-600 mb-6 leading-relaxed">
              Every Amlaria cover is a testament to our commitment to excellence. 
              Inspired by traditional kilim artistry, built for modern protection.
            </p>

            <Link to="/lounge">
              <Button className="bg-amber-600 hover:bg-amber-700 text-white rounded-none px-6 py-3" data-testid="explore-lounge-btn">
                Explore Our Lounge
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>

          {/* Center - Image with Overlay */}
          <div className="lg:col-span-4 flex justify-center">
            <div className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_ce00ca01-0951-4822-8b72-1668a488d246/artifacts/uqsrp4eo_IMG_1070.jpeg"
                alt="Amlaria Lounge"
                className="w-72 h-80 object-cover shadow-2xl"
              />
              {/* Frame */}
              <div className="absolute -inset-2 border-4 border-amber-600/30 pointer-events-none"></div>
              {/* Badge */}
              <div className="absolute -bottom-4 -right-4 bg-amber-600 text-white px-4 py-2 shadow-lg">
                <div className="text-xl font-black">AQ7</div>
                <div className="text-xs opacity-90">CERTIFIED</div>
              </div>
            </div>
          </div>

          {/* Right Side - Stats */}
          <div className="lg:col-span-4">
            <div className="space-y-6">
              <div className="bg-white p-6 shadow-lg border-l-4 border-amber-600">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-amber-100 flex items-center justify-center">
                    <Shield className="h-7 w-7 text-amber-700" />
                  </div>
                  <div>
                    <h4 className="font-bold text-lg text-stone-900">Lifetime Warranty</h4>
                    <p className="text-stone-600 text-sm">Every product guaranteed</p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 shadow-lg border-l-4 border-red-600">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-red-100 flex items-center justify-center">
                    <Star className="h-7 w-7 text-red-700" />
                  </div>
                  <div>
                    <h4 className="font-bold text-lg text-stone-900">4.9 Star Rating</h4>
                    <p className="text-stone-600 text-sm">5000+ happy customers</p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 shadow-lg border-l-4 border-orange-600">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-orange-100 flex items-center justify-center">
                    <Sparkles className="h-7 w-7 text-orange-700" />
                  </div>
                  <div>
                    <h4 className="font-bold text-lg text-stone-900">Premium Materials</h4>
                    <p className="text-stone-600 text-sm">Handpicked for quality</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualitySection;
